module.exports = __webpack_public_path__ + "img/apply-work.dfe07f58.svg";